import { SalteAuth } from '@salte-auth/salte-auth';
import { Redirect } from '@salte-auth/redirect';
import { Okta } from '@salte-auth/okta';
import { config } from '../shared/config';
import { DeereFetch } from '../shared/fetch';

export const auth = new SalteAuth({
    providers: [
        new Okta({
            url: config.auth.url,
            clientID: config.auth.clientId,
            responseType: 'id_token',
            redirectUrl: location.origin,
            scope: 'openid profile',
            routes: true,
            loginType: 'redirect'
        })
    ],
    handlers: [
        new Redirect({
            default: true,
            url: location.origin
        })
    ]
});

let _userPromise = null;
let _user = null;
export class AuthService {
    static logout(provider) {
        auth.logout(provider);
    }

    static get user() {
        if (!_userPromise) {
            _userPromise = DeereFetch('/api/users/current').then((user) => {
                _user = user;
                return _user;
            });
        }

        return _userPromise;
    }

    static get overrideRole() {
        return localStorage.getItem('aui.override-role');
    }

    static get role() {
        const role = _user && _user.role || null;
        if (role === 'ADMIN') {
            return this.overrideRole || role;
        }

        return role;
    }

    static set role(role) {
        localStorage.setItem('aui.override-role', role);
    }

    static name({ id, firstName, lastName, includeID }) {
        if (firstName && lastName) {
            const fullName = `${firstName} ${lastName}`;

            if (includeID) {
                return `${fullName} (${id})`;
            }

            return fullName;
        }

        return id;
    }
}
